export type CustomerType = 'private' | 'business';
export interface PricingItem {
  label: string;
  value: string;
}

export interface LinkItem {
  label: string;
  href: string;
}

export interface LeaseInfo {
  headline: string;
  tooltip: string;
  subline: string;
}

export interface PVFiveInfo {
  title: string;
  subtitle: string;
  tag: string;
  image: {
    src: string;
    alt: string;
    href: string;
  };
  leases: LeaseInfo[];
  tax: {
    label: string;
    value: string;
  };
  priceText: string;
  detailText: string;
  pricing: {
    list: PricingItem[];
  };
  extraLink?: LinkItem;
  links: LinkItem[];
  footer: string[];
}

export type PVFiveCustomerData = Record<CustomerType, PVFiveInfo>;

const sharedInfo = {
  title: 'Kia PV5 Cargo',
  subtitle: 'Kia PV5 Cargo L2H1 4dr Long Range',
  tag: 'El',

  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/kia-pb5-cargo-my26-v1-520x260.png',
    alt: 'Kia PV5',
    href: 'https://www.kia.com/se/pbv/modellutbud/pv5-cargo/',
  },

  tax: {
    label: 'Fordonsskatt',
    value: '360 kr/år',
  },

  links: [
    {
      label: 'Utforska PV5 Cargo här',
      href: 'https://www.kia.com/se/pbv/modellutbud/pv5-cargo/',
    },
  ],

  extraLink: {
    label: 'Prislista PBV: modellversioner och priser',
    href: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/utility/prislista/kia-sweden-pricelist-pbv.pdf',
  },
};

const pvfiveInfo: Record<CustomerType, PVFiveInfo> = {
  business: {
    ...sharedInfo,

    leases: [
      {
        headline: 'Finansiell leasing',
        tooltip:
          'Med finansiell leasing får du en flexibel lösning med många valmöjligheter. Kunden äger bilen och ansvarar för dess restvärde. Leasingavgiften bestäms av bilens nettopris, kapitalkostnaden och fordonets restvärde som sätts baserat på körprofil. Om övriga bilkostnader uppstår hanteras de direkt av kunden.',
        subline: 'inkl. serviceavtal',
      },
    ],

    priceText: '3 165 kr/mån*',

    detailText: `*Företagsleasing via Kia Finans: Beräkningen baseras på att leasegivaren Santander Consumer Bank AS Norge, Sverige Filial (Santander) erhåller stöd från Energimyndigheten i enlighet med förordningen (2020:750) om statligt stöd till vissa miljöfordon. I beräkningen görs antagandet att Santander erhåller ett stöd om 40 000 kr sju månader efter att leasingkontraktet startats. Månad 1-7 är leasinghyran 4 365 kr och månad 8-36 är leasinghyran 2 876 kr. Genomsnittlig månadshyra uppgår till 3 165 kr. Observera att beräkningen förändras beroende på storleken på det stöd som beviljas av Energimyndigheten samt den tidpunkt då Santander erhåller stödet från Energimyndigheten. Avtalstid: 36 månader och restvärde: 204 750 kr. Vid leverans utgår en särskild leasingavgift om 76 440 kr. Uppläggnings- och administrationsavgift tillkommer. Serviceavtal ingår med 236 kr/mån. Samtliga belopp är angivna exklusive moms. Leasingavgiften är rörlig (april 2026) och kan t.ex. ändras p.g.a. förändringar i det allmänna ränteläget. Sedvanlig kreditprövning sker.`,

    pricing: {
      list: [
        {
          label: 'Rek. ca pris exkl. moms',
          value: 'från 455.000 kr',
        },
        {
          label: 'Klimatpremie upp till**',
          value: '-40.000 kr (ej avräknad i rek.pris)',
        },
      ],
    },

    links: [
      ...sharedInfo.links,
      {
        label: '**Läs mer om klimatpremien',
        href: 'https://www.kia.com/se/pbv/plattform-beyond-vehicle/klimatpremie/',
      },
    ],

    footer: [
      'Individuella företagsrabatter och finansieringsupplägg kan påverka exempelpriserna visade ovan.',
      'Kontakta din Kia-återförsäljare för ett skräddarsytt affärsförslag och ev. anpassning av ditt fordon.',
    ],
  },

  private: {
    ...sharedInfo,

    leases: [],

    priceText: '',

    detailText: '',

    pricing: {
      list: [
        {
          label: 'Rek. ca pris inkl. moms',
          value: 'från 568 750 kr',
        },
      ],
    },

    footer: [],
  },
};

export default pvfiveInfo;
